<!-- Loading State -->
@if (loading()) {
<div class="flex items-center justify-center py-12">
  <div class="flex items-center space-x-2">
    <i
      data-testid="pos-shift-close-view-loading"
      class="pi pi-spin pi-spinner text-blue-600"
    ></i>
    <span class="text-gray-600">{{
      "common.messages.loading" | translate
    }}</span>
  </div>
</div>
}

<!-- Content -->
@if (!loading() && shiftClosing()) {
<div class="space-y-2">
  <!-- Basic Shift Information -->
  <app-add-form
    data-testid="pos-shift-close-view-form"
    [title]="config.title"
    [formFields]="config.formFields"
    [headerActions]="config.headerActions"
    [editMode]="false"
    [viewMode]="true"
    [initialData]="shiftClosing()"
    (formValueChanges)="onFormValueChanges($event)"
    (formAction)="onFormAction($event)"
  ></app-add-form>

  <div class="px-6">
    
      <!-- Sales Summary Section -->
      @if (salesSummary()) {
      <section
        data-testid="pos-shift-close-view-section-sales-summary"
        class="form-section mb-2 px-2"
      >
        <div class="flex items-center">
          <h2 class="section-title text-sm mr-4">
            {{ "pos.shift_close.detail.sections.sales_summary" | translate }}
          </h2>
        </div>
        <div class="grid gap-2 px-4 py-2 grid-cols-3 mt-1">
          @for (item of getSummaryItems(); track item.label; let itemIndex = $index) {
          <div
            class="form-field"
            [attr.data-testid]="'pos-shift-close-view-summary-field-' + itemIndex"
          >
            <label class="form-label text-sm">
              {{ item.label | translate }}
            </label>
            <p-inputNumber
              [attr.data-testid]="'pos-shift-close-view-summary-input-' + itemIndex"
              [ngModel]="item.value"   
              [disabled]="true"
              [useGrouping]="true"
              [currency]="item.formatter === 'currency' ? 'VND' : undefined"
              [locale]="item.formatter === 'currency' ? 'vi-VN' : undefined"
              [suffix]="item.formatter === 'currency' ? ' ₫' : undefined"
              class="w-full text-sm"
              [class.currency-amount]="item.formatter === 'currency'"
            ></p-inputNumber>
          </div>
          }
        </div>
      </section>
      }

    <!-- Data Tables Section -->
    @for (section of getDataTableSections(); track section.title; let sectionIndex = $index) {
      @if (section.data.length > 0) {
        <div class="p-2 border-t border-gray-200">
          <h2 class="section-title text-sm mt-1">
            {{ section.title | translate }}
          </h2>
        </div>
        <div class="px-6 py-2 mb-2">
          <app-data-table
            [attr.data-testid]="'pos-shift-close-view-table-' + sectionIndex"
            [dataSource]="section.data"
            [columns]="section.columns"
            [loading]="false"
            [totalRecords]="section.data.length"
            [rows]="20"
            [first]="0"
            [hasCheckColumn]="false"
            [hasSerialColumn]="false"
            [scrollHeight]="'21.5vh'"
          >
            <ng-template #customTemplate let-value let-column="column">
              @if (column.template === 'dateTemplate') {
                <span class="text-xs text-gray-600 flex items-center justify-center">
                  {{ formatDateTime(value) }}
                </span>
              }
              @else if (column.template === 'currencyTemplate') {
                <span class="text-xs text-gray-600 flex items-center justify-end">
                  {{ formatCurrency(value) }}
                </span>
              }
            </ng-template>
          </app-data-table>
        </div>
      }
    }
  </div>
</div>
}
